<template>
  <div class="order-summary-component">
    <div class="card">
      <div class="card-body">
        <ul class="mt-2" :class="extrasExpanded ? 'mb-3' : ''">
          <li
            @click="extrasExpanded = !extrasExpanded"
            class="
              d-flex
              align-items-center
              justify-content-between
              cursor-pointer
            "
          >
            <div class="d-flex align-items-center">
              <div v-show="extrasExpanded">
                <i class="far fa-chevron-up me-3"></i>
              </div>
              <div v-show="!extrasExpanded">
                <i class="far fa-chevron-down me-3"></i>
              </div>

              <span class="name">Step 1 Extras</span>
            </div>

            <span class="ms-2 price font-weight-bolder"
              >&pound;{{ order.eyesite_total | money }}</span
            >
          </li>
          <li
            v-for="extra in order.extras"
            :key="extra.id"
            class="align-items-center justify-content-between"
            :class="extrasExpanded ? 'd-flex' : 'd-none'"
          >
            <a
              v-if="extra.thumbnail_url"
              :href="extra.thumbnail_url"

              title="Click to enlarge"
            >
              <img
                :src="extra.thumbnail_url"
                :alt="extra.name"
                class="me-3"
                width="150"
              />
            </a>
            <div class="w-100 ms-3 d-flex justify-content-between">
              <span class="name me-2"
                >{{ extra.room ? `${extra.room}: ` : "" }}{{ extra.type ? `${extra.type} - ` : "" }}{{ extra.name }}
                <small v-if="extra.description" class="text-muted d-block">{{
                  extra.description
                }}</small></span
              >
              <span class="ms-2 price font-weight-bolder"
                ><span v-if="extra.total_refunded > 0" class="me-2"
                  >(Refunded: -&pound;{{ extra.total_refunded | money }})</span
                >&pound;{{ extra.price | money }}</span
              >
            </div>
          </li>
        </ul>

        <ul class="mb-2">
          <li
            v-for="(item, productId) in order.items"
            :key="productId"
            class="d-flex justify-content-between"
          >
            <span class="name"
            >{{
                item.product && item.product.parent
                  ? item.product.parent.name + " - " + item.product.name
                  : (item.product && item.product.name ? item.product.name : "Unknown Product")
              }}
              x {{ item.quantity }}</span
            >
            <span class="ms-2 price font-weight-bolder"
              ><span v-if="item.total_refunded > 0" class="me-2"
                >(Refunded: -&pound;{{ item.total_refunded | money }})</span
              >&pound;{{ item.line_total | money }}</span
            >
          </li>

          <li
            v-for="refund in nonAttachedRefunds"
            :key="refund.id"
            class="d-flex justify-content-between"
          >
            <span class="name"
              >Refund {{ refund.created_at | moment("L - LT") }}</span
            >
            <span class="ms-2 price font-weight-bolder"
              >-&pound;{{ refund.amount | money }}</span
            >
          </li>
        </ul>

        <div
          class="
            total
            d-flex
            flex-wrap flex-xl-nowrap
            justify-content-between
            align-items-center
          "
        >
          <h6
            class="mb-0 w-100 w-xl-auto"
            v-if="order.payment && order.payment.brand && order.payment.type"
          >
            {{ order.payment.brand.toTitleCase() }}
            {{ order.payment.type.toTitleCase() }} Payment
            <span v-if="order.payment.last_4_card"
              >({{ order.payment.last_4_card }})</span
            >
          </h6>
          <h6 class="mb-0 font-weight-bolder text-right w-100">
            <span v-if="order.discount_total > 0">
              Discount: -&pound;{{ order.discount_total | money }}<br/>
            </span>
            <span v-if="order.total_refunded > 0">
              Refunded: -&pound;{{ order.total_refunded | money }}<br/>
            </span>
            Total: &pound;{{ order.total_net | money }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      extrasExpanded: false,
    };
  },

  props: {
    order: {
      type: Object,
      default: null,
    },
  },

  computed: {
    nonAttachedRefunds() {
      return this.order && this.order.payment && this.order.payment.refunds
        ? this.order.payment.refunds.filter(
          (r) => r.order_item_id === null && r.order_extra_id === null
        )
        : [];
    },
  },

  watch: {
    //
  },

  created() {
    //
  },

  methods: {
    //
  },
};
</script>
